<template>
  <div
    class="d-flex align-items-center v2_color_white"
    id="profile-popover-target"
  >
    <span class="mr-2">
      <i class="mdi mdi-account-circle-outline font_size_1500rem" aria-hidden="true" />
    </span>
    <router-link to="/profile" class="font_size_875rem v3_color_white">{{ userName ? userName : userEmail }}</router-link>
    <div class="ml-2">
      <UserLogout class="mx-0" v-if="userEmail" />
    </div>
  </div>
</template>

<script>
import UserLogout from '@/components/UserLogout';

export default {
  name: 'UserNavSection',
  props: {
    userEmail: String,
    userName: String,
  },
  components: {
    UserLogout,
  },
};
</script>

<style scoped/>
